import React, { Component } from "react";
import FlexView from "react-flexview";
import { NavLink } from "react-router-dom";
import Container from "../../../../modules/commons/Container";

class DashboardCrmCoordinator extends Component {
    createSubMenu = (val, link, icon, id) => {
        return (
            <NavLink id={id} to={link}>
                <div
                    style={{
                        backgroundColor: "#E74C3C",
                        width: 235,
                        height: 235,
                        margin: 'auto',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column' ,
                        borderWidth: 2,
                        borderColor: "#000000",
                        borderStyle: "solid",
                        borderRadius: 5,
                    }}
                >
                    <div
                        style={{
                             color: "#ffffff"
                        }}
                    >
                        <div className="icn" style={{margin: 10}}>
                            <i className={`${icon} fa-lg`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                    </div>
                </div>
            </NavLink>
        );
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px"}}>
                        {this.createSubMenu(
                            "Laporan Prospek Monitoring Team",
                            "/dashboard/crm-coordinator/team-leader-report",
                            "fa fa-lg fa-tv",
                            "btn_navigate_report_prospek_monitoring_team"
                        )}
                        {this.createSubMenu(
                            "Laporan Prospek Daily",
                            "/dashboard/crm-coordinator/daily-report",
                            "fa fa-lg fa-tv",
                            "btn_navigate_report_prospek_daily"
                        )}
                    </FlexView>
                </Container>
            </>
        )
    };

}

export default DashboardCrmCoordinator;